import React from 'react';
import renderContentfulBody from '../richTextRenderer/renderContentfulBody';
import getThemeClass from '../../../utils/getThemeClass';
import styles from './TextCard.module.css';

/** @param {FF.ContentfulTextCard} props */
export default function TextCard({ backgroundColor, body, className }) {
  return (
    <li
      className={`${styles.wrapper} ${className} ${getThemeClass(
        backgroundColor,
      )}`}
    >
      {renderContentfulBody(body)}
    </li>
  );
}
